import React, { PureComponent } from 'react'
import { string, func, bool } from 'prop-types'
import Button from '@active/react-ui/Button'
import DefaultComponentLayout, { LayoutContent } from '../../Layout'
import I18nMessage from '../../I18nMessage'
import Confirm from '../../Confirm'

const trackInfo = {
  eventName: 'SentEmailNotice',
  widget: 'Sent_Email_Notice',
  pageType: 'Sent Email Notice',
}

function handleComplete() {
  window.close()
}
class SentEmailNotice extends PureComponent {
  static propTypes = {
    email: string.isRequired,
    Header: func.isRequired,
    goBack: func,
    configureTrack: func.isRequired,
    countToClose: bool,
    messageContent: string,
    hideEmail: bool,
  }

  static defaultProps = {
    goBack: undefined,
    countToClose: false,
    messageContent: 'passport.forgotPwd.notice.haveSentEmailTo',
    hideEmail: false,
  }

  render() {
    const {
      email, goBack, Header, configureTrack, countToClose, messageContent, hideEmail,
    } = this.props
    return (
      <DefaultComponentLayout
        nameSpace="passport__sent-email-notice"
        Header={Header}
      >
        <LayoutContent
          subTitle
          message={messageContent}
        />
        <LayoutContent main>
          {!hideEmail && (
            <span className="text-font-18 font-weight-600 passport__wordbreak">
              {email}
            </span>
          )}
          {goBack && (
            <Button className="btn-secondary btn-back" onClick={goBack}>
              <I18nMessage id="passport.common.btn.back" />
            </Button>
          )}
          {countToClose && (
            <Confirm
              trackInfo={trackInfo}
              handleComplete={handleComplete}
              configureTrack={configureTrack}
              countToClose={countToClose}
            />
          )}
        </LayoutContent>
      </DefaultComponentLayout>
    )
  }
}

export default SentEmailNotice
